import { Directive, EventEmitter, Output } from '@angular/core';

/**
 * BaseModal is an abstract class that provides a common structure for all modals in the application. It has two events:
 *  - modalOpened: An event that is emitted when the modal is opened.
 *  - modalClosed: An event that is emitted when the modal is closed.
 */
@Directive()
export abstract class BaseModal {
  @Output() public modalOpened = new EventEmitter<void>();
  @Output() public modalClosed = new EventEmitter<void>();

  protected isModalOpen = false;

  /**
   * You can override this method in the child component if you want to execute some code when the modal is opened. Just make sure to call super.openModal() to trigger the modalOpened event.
   */
  public openModal(): void {
    this.isModalOpen = true;
    this.modalOpened.emit();
  }

  /**
   * You can override this method in the child component if you want to execute some code when the modal is closed. Just make sure to call super.closeModal() to trigger the modalClosed event.
   */
  public closeModal(): void {
    this.isModalOpen = false;
    this.modalClosed.emit();
  }
}
